// How an Auth account reads on the users pages.

/** The name to show for an account: its name, its email, or "Anonymous". */
export function accountLabel(user, t) {
  return user.displayName || user.profile?.name || user.email || t('users.anonymous')
}

/** A date the Auth API gave us as a string, in the dashboard's language. */
export function formatAuthDate(value, lang) {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString(lang)
}
